<template>
  <div id="Web3DView">
     <div class="map-wrap-3d" :style="panelStyle" v-show="showMap" ref="mapWrap">
         <div v-show="!minimizeMapState" class="map-inner-wrap">
         <div class="map-wrap-top">
             <div class="map-left">
             </div>
             <div class="map-right">
                 <div class="map-right-div" style="margin-right:10px" @click="minimizeMap">
                      <i class="iconfont icon-suoxiao"></i>
                 </div>
                 <div class="map-right-div" @click="changeMapSize">
                      <i class="iconfont icon-fangda"></i>
                 </div>
             </div>
         </div>
         <div class="out-wrap">
             <mapView id='mapView' ref='mapView'></mapView>
         </div>
           
         </div>
         <div v-if="minimizeMapState">
              <div class="miniMap" @click="reviewMap">
                  <i class="iconfont icon-fangda"></i>
              </div>
         </div>
    </div>
    <!-- <ViewBasicControl @menuCommand='executeMenuCommand'></ViewBasicControl> -->

    <!-- <CommonControlPanel></CommonControlPanel> -->
    <BadControlPanel @controlBadCommand="controlBadCommand" ref="badControlPanel"></BadControlPanel>
    <NavControlPanel @controlNavCommand='controlNavCommand' ref='navControlPanel'></NavControlPanel>
    <FlyControlPanel @controlFlyCommand='controlFlyCommand' ref='flyNavControlPanel'></FlyControlPanel>

   <!--  <MainControlPanel id='mainControlPanel' @mainControlCommand='mainControlCommand' ref ='mainControlPanel'></MainControlPanel> -->
   <!--  <DefectListPanel></DefectListPanel> -->


    <ModelModificationPanel id='modelModifiPanel' @modelModificationCommand='modelModificationCommand' ref ='modelModificationPanel'></ModelModificationPanel>
    <PropWinowManager  :propWinDataObj='propWinDataObj' ref='propertyWindow' ></PropWinowManager>


    <!-- Div which will hold the Output -->
    <div id="WebGL-output" v-loading="taskManager.loading" :element-loading-text=taskManager.taskName>
      <el-progress class='progressbar' status='success' :text-inside="true" :show-text='false' :stroke-width="15" :percentage=taskManager.percentage v-if=taskManager.loading></el-progress>
    </div>

    <!-- 桩号显示 -->
    <div id='statusCard' v-if="showStatusCard" :style="statusCardStyle">
      起始桩号：<span style='padding:0px;'>{{curCoordDesc|fStartStake}}</span>
    </div>

    
  </div>
</template>
<script>
  import mapView from './map';
import * as THREE from 'three';
import { CARD1Web, MouseAction } from '@/drawings3D/CoordUtils.js'
import { SceneManager } from '@/drawings3D/sceneManager.js'
import { ApiManager } from '@/js/apis/apimanager.js'
import { RoadDrawer } from '@/drawings3D/modelDrawing/RoadDrawer.js'

import { AsyncTask } from '@/js/task.js'
import ViewBasicControl from '@/components/Web3dModels/ViewBasicControls'
import RoadUnitData from '@/components/Web3dModels/RoadUnitData'
import NavControlPanel from '@/components/Web3dModels/NavControlPanel'
import FlyControlPanel from '@/components/Web3dModels/FlyControlPanel'
import MainControlPanel from '@/components/Web3dModels/MainControlPanel'
import ModelModificationPanel from '@/components/Web3dModels/ModelModificationPanel'
// import CommonControlPanel from '@/components/Web3dModels/CommonControlPanel'
import BadControlPanel from '@/components/Web3dModels/BadControlPanel'

import {ModelLoader} from '@/drawings3D/ModelLoader'
import PropWinowManager from '@/components/PropertyWindows'
import {RoadManager} from '@/drawings3D/RoadManager'
import DefectListPanel from '@/components/Web3dModels/DefectListPanel'
import {ResourceLoader} from '@/drawings3D/ResourceLoader'

export default {
  name: 'Web3DView',
  components: { ViewBasicControl, RoadUnitData, NavControlPanel, FlyControlPanel, MainControlPanel, ModelModificationPanel, PropWinowManager,DefectListPanel, mapView,BadControlPanel},
  data: function() {
    return {
      camera: '',
      scene: '',
      renderer: '',
      loading: true,
      taskManager: new AsyncTask(),
      curCoordDesc:'',
      propWinDataObj:{window:''},
      mapSize:1,
      panelStyle:'left:15px;bottom:0;',
      statusCardStyle:'right:16px;bottom:0;',
      showStatusCard:false,
      showMap:false,
      roadPartOption:{
        mediaDividers:true,
        guardRails:true,
        laneDividers:true
      },
      carSpeed:80,
      flySpeed:20,
      flyHeight:50,
      minimizeMapState:false,
      mapWrapWidth:'',
      mapWrapHeight:''
    }
  },
  mounted: function() {

    this.map= this.$refs.mapView;
    this.$refs.mapView.web3DModel = this;

    this.sceneManager = new SceneManager("WebGL-output", this);
    this.apiManager = new ApiManager(this);

    var resourceLoader = new ResourceLoader();
    resourceLoader.loadTextures();
    CARD1Web.Resources=resourceLoader;

    var that = this;
    if (this.$parent.beforeWeb3DVueInit){
      this.$parent.beforeWeb3DVueInit.call(this.$parent);
    }
    // this.sceneManager.getRoadManager().drawRoadStakes(0, 1000, 1, that.$parent.afterModelLoaded, that.$parent, this.roadPartOption);  
    this.sceneManager.getRoadManager().drawRoadStakeByPos(103.82851105262998, 25.400434066834475, that.$parent.afterModelLoaded, that.$parent, true,this.roadPartOption);  

    $('#WebGL-output').on('click', function(event) {
      var selObj = that.sceneManager.checkClickObj(MouseAction.CLICK, that);
     
    });

    $("#WebGL-output").bind("contextmenu", function () {
        var selObj = that.sceneManager.checkClickObj(MouseAction.RIGHTCLICK, that);
    });

    $('#WebGL-output').on('mousemove', function(event) {
      
      that.sceneManager.checkClickObj(MouseAction.MOUSEMOVE, that);
    });

    this.sceneManager.render(this);
    $('#modelModifiPanel').hide();
  },
  methods: {
    executeMenuCommand: function(e) {
      e.command.exec.call(e.command, this);
    },
    controlNavCommand: function(e) {
      e.command.exec.call(e.command, this);
    },
    controlFlyCommand: function(e) {
      e.command.exec.call(e.command, this);
    },
    controlBadCommand: function(e) {
      e.command.exec.call(e.command, this);
    },
    modelModificationCommand : function(e){
      e.command.exec.call(e.command, this);
    },
    mainControlCommand : function(e){
      e.command.exec.call(e.command, this);
    },
    selectStake: function(e) {
    var roadUnit = this.sceneManager.getRoadManager().selectStake(e, 'someroad');
      if (roadUnit == undefined) return;
      this.$refs.roadUnitData.updateData(roadUnit, this);
    },
    nextStake: function(e) {
      var roadUnit = this.sceneManager.getRoadManager().selectNextStake(e, 'someroad');
      if (roadUnit == undefined) return;
      this.$refs.roadUnitData.updateData(roadUnit, this);
      this.$refs.roadUnitData.stakeNo = roadUnit.start.stakeval;
    },
    prevStake: function(e) {
      var roadUnit = this.sceneManager.getRoadManager().selectPrevStake(e, 'someroad');
      if (roadUnit == undefined) return;
      this.$refs.roadUnitData.updateData(roadUnit, this);
      this.$refs.roadUnitData.stakeNo = roadUnit.start.stakeval;
    },
    render() {
      
      this.sceneManager.render(this);
    },

    changeMapSize(){
        if(this.mapSize==1){
           $('.map-wrap-3d').css({height:'573px'});
           this.$refs.mapView.resetMap();
           this.mapSize=2
        }else if(this.mapSize==2){
           $('.map-wrap-3d').css({height:'173px'});
           $('.map-wrap-3d .out-wrap').css({height:'131px'});
           this.mapSize=1
           this.$nextTick(()=>{
               this.$refs.mapView.resetMap(); 
           })
        }
    },
    adjStyle(style){
        this.panelStyle= style;
    },
    showPanel(panelInfo){
      this.$emit('showPanel',panelInfo);
    },
    flyTips(){
       this.$message({
          type:'warning',
          message:'请先退出模拟驾驶！',
          duration:700,
       })
    },
    carTips(){
       this.$message({
          type:'warning',
          message:'请先退出模拟飞行！',
          duration:700,
       })
    },
    sendCarSpeed(){
      this.$emit('getCarSpeed',this.carSpeed);
    },
    sendFlySpeed(){
      this.$emit('getFlySpeed',this.flySpeed);
    },
    sendFlyHeight(){
      this.$emit('getFlyHeight',this.flyHeight); 
    },
    sendError(){
       this.$message({
          type:'warning',
          message:'输入错误，请检查输入数据',
          duration:700
       })
    },
    sendMessage(type,message){
       this.$message({
          type:type,
          message:message,
          duration:700
       })
    },
    endAnimateLocus(){
        this.$emit('endAnimateLocus');
        this.apiManager.drawApi.endAnimateLocus();
    },
    tipsSos(uuid,name){
       //涉及到dom，必须在页面被加载出来再执行,也可以不用setTimeout来解决，用promise也可
       let data={
          uuid,
          name
       }
       setTimeout(()=>{
          this.$emit('tipsSos',data);
       },4000)
    },
    tipsSosSync(uuid,name){
        let data={
          uuid,
          name
       }
       this.$emit('tipsSos',data);
    },
    minimizeMap(){
        var that=this;
        this.mapWrapHeight=this.$refs.mapWrap.offsetHeight;
        this.mapWrapWidth=this.$refs.mapWrap.offsetWidth;
        $('.map-wrap-3d').animate({
          width:'40px',
          height: '40px'}, function() {
            that.minimizeMapState=true;
          /* stuff to do after animation is complete */
        });

    },
    reviewMap(){
        var that=this;
        $('.map-wrap-3d').animate({
          width:this.mapWrapWidth+'px',
          height: this.mapWrapHeight+'px'}, function() {
            that.minimizeMapState=false;
          /* stuff to do after animation is complete */
        });
    },
    afterModelLoad(info){
        this.$emit('afterModelLoad',info);
    },
    mapTo3d(lonlat){
        this.$emit('mapTo3d',lonlat);
    }
  },
  filters:{
    fStartStake:function(value){
      if(value==null||value==''){
         return '--'
      }else{
        let rice=value%1000;
        let Kilometer=parseInt(value/1000);
        rice=rice.toString();
        if(rice==undefined){
            rice='000'
        }else if(rice.length==1){
            rice='00'+rice;
        }else if(rice.length==2){
            rice='0'+rice;
        }
        return 'K'+Kilometer+'+'+rice 

      }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped rel="stylesheet/less">
@import '../../assets/css/style.less';
@import '../../assets/css/mixin.less';

/*.modelTips{
   padding:0 10px;
   height:30px;
   border-radius:4px;
   line-height:30px;
   font-size:12px;
   color:#fff;
   text-align: center;
   background-color:#253924;
}*/

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #42b983;
}
#Web3DView{
  .wh(100%,100%);
}
.progressbar {
  z-index: 10000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 240px;
  width: 400px;
  padding-top: 350px;
}

#WebGL-output {
  padding:0;
  overflow:hidden;
  height:auto;
}

#statusCard{
  position:absolute;
  width:166px;
  height:40px;
  padding:0px;
  color:#fff;
  line-height:40px;
  text-align: center;
  font-size:14px;
  box-sizing: border-box;
  border: 1px solid #14171c;
  background: linear-gradient(0deg,#1e202a,#0d1013);
  box-shadow: inset 0 0 0 1px #575757, 0 2px 21px 0 rgba(33,34,39,.55);
  opacity: .85;
  border-radius: 2px;
}
#modelModifiPanel{
 position:absolute;
  right:0px;
  top:0px;
  width:380px;
  height:30px;
  padding:0px;
  -webkit-animation: none;
  -moz-animation:none;
  animation:none; 
}

/*#mapView{
        position:absolute;
        left:20px;
        top: 200px;
        width:362px;
        height:362px;
        background-image:url('/static/bimroad/imgs/mapbg.png');
       } 

       #stakeSearcher{
          position:absolute;
          left:20px;
          top:120px;
          width: 362px;
          height:53px;
          background-image:url('/static/bimroad/imgs/searchbg.png'); 
          #stakeSearchInput{
           position:absolute;
            bottom:15px; 
            left:40px;
            border:0px;
            background-color:transparent;
            color:#227AE4;
            font-size:14px;
          }
           input::-webkit-input-placeholder{
            color:#227AE4;
            font-size:14px;
        }
      }*/
        
.map-wrap-3d{
        position:absolute;
        z-index:20;
        padding:0 10px;
        box-sizing: border-box;
        border: 1px solid #14171c;
        background: linear-gradient(0deg,#1e202a,#0d1013);
        box-shadow: inset 0 0 0 1px #575757, 0 2px 21px 0 rgba(33,34,39,.55);
        opacity: .85;
        border-radius: 2px;
        overflow:hidden;
        height:173px;
        .map-inner-wrap{
           width:100%;
           height:100%;
           box-sizing:border-box;
           display:flex;
           flex-direction:column;
        }
        .miniMap{
           .wh(100%,40px);
           display:flex;
           align-items:center;
           .icon-fangda{
              .sc(20px,#fff);
           }
        }
         .map-wrap-top{
            .wh(381px,40px);
            flex-shrink:0;
            display:flex;
            justify-content:space-between;
            align-items:center;
            .map-left{
               display:flex;
               align-items:center;
               .icon-left{
                  .sc(10px,#fff);
               }
               span{
                  .sc(14px,#fff);
               }
            }
            .map-right{
                 display:flex;
                 .map-right-div{
                   cursor:pointer;
                   .icon-fangda{
                       .sc(21px,#fff);
                   }
                   .icon-suoxiao{
                       .sc(21px,#fff);
                   }
                 }
            }
         }
         .out-wrap{
            flex:1;
            width:100%;
         }
      }
      .circle-div{
          width:40px;
          height:40px;
          border-radius:50%;
          background-color:yellow;
      }
</style>



// WEBPACK FOOTER //
// src/plugins/page/main/Web3DView.vue